import { hrApiClient } from '@/lib/api/clients';
import { IListResponse } from '@/shared';
import { BannerListDto } from '@/shared/banner';
import { CreateBannerActivityInput } from '@/shared/banner-activity';

export async function getBannerList(
  id: number
): Promise<IListResponse<BannerListDto>> {
  const { data } = await hrApiClient.get<IListResponse<BannerListDto>>(
    '/banner/list',
    { params: { id } }
  );

  return data;
}

export async function createBannerActivity(
  input: CreateBannerActivityInput
): Promise<void> {
  await hrApiClient.post('/banner-activity', input);
}
